module.exports = __webpack_public_path__ + "img/SketchPngb0234b92e382ab9878c54affd6f0e1728d494dab2a6c1df1b59d89617b8aeb2c.36c933ec.png";